const PlusIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 1L9 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      <path d="M1 9L17 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  );
};

export default PlusIcon;
